// Local storage keys
export const USER_ID = 'userId';
export const LOCAL_STORAGE_KEY_MAP_UNITS = 'mapUnits';

export const LOCAL_STORAGE_KEY_ACQUISITION_COST = 'maAcquisitionCost';
export const LOCAL_STORAGE_KEY_PRICE_BARREL = 'maPriceBarrel';

export const SESSIONS_STORAGE_KEY_GROUP_BY_PREFERENCE =
  'IS_GROUP_BY_REGION_COUNTRY_AREA_AUTOCOMPLETE';

export const SESSION_STORAGE_KEY_MA_CB_CH2_STACK = 'SESSION_STORAGE_KEY_MA_CB_CH2_STACK';

// Paths
export const ROOT_PATH = '/';
export const DEFAULT_PATH = '*';
export const PORTFOLIO_ANALYSIS_PATH = '/portfolio-analysis';

// M&A Paths
export const M_A_BASIC_PATH = '/m-a';

// M&A Transactions Paths
export const M_A_TRANSACTIONS_PATH = `${M_A_BASIC_PATH}/transactions`;
export const M_A_TRANSACTIONS_OVERVIEW_PATH = `${M_A_TRANSACTIONS_PATH}/#overview`;
export const M_A_TRANSACTIONS_TABLE_PATH = `${M_A_TRANSACTIONS_PATH}/#table`;
export const M_A_TRANSACTIONS_ANALYTICS_PATH = `${M_A_TRANSACTIONS_PATH}/#analytics`;
export const M_A_TRANSACTIONS_COMPANY_ANALYSIS_PATH = `${M_A_TRANSACTIONS_PATH}/#analysis`;

// M&A Opportunities Paths
export const M_A_OPPORTUNITIES_PATH = `${M_A_BASIC_PATH}/opportunities`;
export const M_A_OPPORTUNITIES_ANALYTICS_PATH = `${M_A_OPPORTUNITIES_PATH}/#analytics`;
export const M_A_OPPORTUNITIES_TABLE_PATH = `${M_A_OPPORTUNITIES_PATH}/#table`;

// Video Tutorials Paths
export const VIDEO_TUTORIALS_PATH = '/tutorials';

export const COUNTRY_OVERVIEWS_PATH = '/country-overviews';
export const CCUS_PATH = '/ccus';
// Feature flag: enable_consolidated_live_models
export const CLM_PATH = '/consolidated-live-models';
export const FORGOT_PASSWORD_PATH = '/forgot-password';
export const GHG_PATH = '/ghg';
export const GHG_SCOPE_3_PATH = '/scope-3';
export const REGISTER_PATH = '/register';
export const RESET_PASSWORD_PATH = '/reset-password';
export const SETTINGS_PATH = '/settings';
export const SIGN_IN_PATH = '/login';
export const OAUTH2_SIGN_IN_PATH = '/oauth2/callback';
export const SIGN_UP_PATH = '/sign-up';
export const CONFIRMATION_PATH = '/confirmation';

export const ADMINS_PATH = '/admins-portal';
export const ADMINS_CLIENTS_PATH = `${ADMINS_PATH}/clients`;
export const ADMINS_USERS_PATH = `${ADMINS_PATH}/users`;
export const ADMINS_SUBSCRIBER_DOWNLOADS_PATH = `${ADMINS_PATH}/subscriber-downloads`;
export const ADMINS_INDUSTRY_TRACKERS_PATH = `${ADMINS_PATH}/industry-trackers`;
export const ADMINS_EA_WELLS_PATH = `${ADMINS_PATH}/ea-wells`;
export const ADMINS_LEAD_ANALYSTS_PATH = `${ADMINS_PATH}/lead-analysts`;
export const ADMINS_LNG_FACILITIES_PATH = `${ADMINS_PATH}/lng-facilities`;
export const ADMINS_FEATURES_PATH = `${ADMINS_PATH}/features`;
export const ADMINS_CCUS_PATH = `${ADMINS_PATH}/ccus-data-import`;
export const ADMINS_GIS_FILES_PATH = `${ADMINS_PATH}/gis-files`;
export const ADMINS_CONSOLIDATED_CASHFLOW_TEMPLATES_PATH = `${ADMINS_PATH}/consolidated-cashflow-templates`;

// Data Ingestion Tool Paths
export const ADMINS_DIT_PATH = `${ADMINS_PATH}/data-ingestion-tool`;
export const ADMINS_DIT_EVENT_PATH = `${ADMINS_DIT_PATH}/:id`;

// Smart Reports Paths
export const ADMINS_SMART_REPORTS_PATH = `${ADMINS_PATH}/smart-reports`;
export const ADMINS_SMART_REPORTS_NEW_PATH = `${ADMINS_SMART_REPORTS_PATH}/new`;
export const ADMINS_SMART_REPORTS_EDIT_REPORT_PATH = `${ADMINS_SMART_REPORTS_PATH}/:id/edit`;
export const ADMINS_SMART_REPORTS_VIEW_REPORT_PATH = `${ADMINS_SMART_REPORTS_PATH}/:id/view`;
export const ADMINS_SMART_REPORTS_PREVIEW_REPORT_PATH = `${ADMINS_SMART_REPORTS_PATH}/:id/preview`;

// Admin MaDeals Paths
export const ADMINS_MA_DEALS_PATH = `${ADMINS_PATH}/ma-deals`;
export const ADMINS_MA_DEALS_DETAILS_PATH = `${ADMINS_MA_DEALS_PATH}/:id`;

// Nexus Admin Paths
export const ADMINS_NEXUS_PATH = `${ADMINS_PATH}/nexus`;
export const ADMINS_JOB_STATUS_PATH = `${ADMINS_NEXUS_PATH}/job-status`;
export const ADMINS_ENTITY_NAME_CORRECTIONS_PATH = `${ADMINS_NEXUS_PATH}/entity-name-corrections`;
export const ADMINS_EDIT_ENTITY_NAME_CORRECTIONS_PATH = `${ADMINS_ENTITY_NAME_CORRECTIONS_PATH}/:id`;
export const ADMINS_MODEL_INPUTS_PATH = `${ADMINS_NEXUS_PATH}/model-inputs`;
export const ADMINS_MODEL_INPUTS_ASSETS_PATH = `${ADMINS_MODEL_INPUTS_PATH}/assets/:uuid`;

export const GUIDANCE_DOCUMENTATION_PATH = '/guidance-documentation';
// TODO #1059 - Uncomment when price assumptions page is ready
// export const PRICE_ASSUMPTIONS_PATH = '/guidance-documentation/price-assumptions';
export const RESERVES_DEFINITION_PATH = '/guidance-documentation/reserves-definition';
export const WEA_ASSUMPTIONS_PATH = '/guidance-documentation/wea-assumptions';

// Data Downloads Paths
export const DATA_DOWNLOADS_PATH = '/data-downloads';
export const GLOBAL_DOWNLOADS_PATH = `${DATA_DOWNLOADS_PATH}/global-downloads`;
export const GLOBAL_DOWNLOADS_PATH_WITH_DOWNLOADSPANE = `${GLOBAL_DOWNLOADS_PATH}/:downloadsPane`;

// Customer Paths
export const CUSTOMER_PATH = '/customer';
export const PROPRIETARY_DOWNLOADS_PATH = `${CUSTOMER_PATH}/proprietary-downloads`;
export const CUSTOMER_DOWNLOADS_PATH = `${CUSTOMER_PATH}/proprietary-downloads/:slug`;

// Oil and Gas Map Paths
export const OIL_AND_GAS_MAP_PATH = '/oil-and-gas-map';
export const OIL_AND_GAS_MAP_PATH_WITH_LATLONG = `${OIL_AND_GAS_MAP_PATH}/:latLong`;
export const OIL_AND_GAS_MAP_PATH_WITH_LATLONG_AND_ZOOM = `${OIL_AND_GAS_MAP_PATH}/:latLong/:zoom`;

// Valuations Paths

export const VALUATIONS_V2_PATH = '/valuations-v2';
export const VALUATIONS_V2_ASSET_PATH = `${VALUATIONS_V2_PATH}/:countryIsoCode/:legacyId`;

export const VALUATIONS_PATH = '/valuations';
export const VALUATIONS_ASSET_PATH = `${VALUATIONS_PATH}/:countryIsoCode/:legacyId`;
export const VALUATIONS_ASSET_REPORT_PATH = `${VALUATIONS_PATH}/:countryIsoCode/:legacyId/:report`;

export const LNG_ASSET_VALUATION_PATH = '/lng-asset-valuation';

export const PUBLIC_PATHS = [
  FORGOT_PASSWORD_PATH,
  REGISTER_PATH,
  RESET_PASSWORD_PATH,
  SETTINGS_PATH,
  SIGN_IN_PATH,
  SIGN_UP_PATH,
  OAUTH2_SIGN_IN_PATH,
  CONFIRMATION_PATH,
  RESERVES_DEFINITION_PATH,
  WEA_ASSUMPTIONS_PATH,
  GUIDANCE_DOCUMENTATION_PATH,
];

const NEXUS_PATHS = [
  ADMINS_JOB_STATUS_PATH,
  ADMINS_ENTITY_NAME_CORRECTIONS_PATH,
  ADMINS_EDIT_ENTITY_NAME_CORRECTIONS_PATH,
];

export const ADMIN_PATHS = [
  ADMINS_PATH,
  ADMINS_CLIENTS_PATH,
  ADMINS_USERS_PATH,
  ADMINS_SUBSCRIBER_DOWNLOADS_PATH,
  ADMINS_INDUSTRY_TRACKERS_PATH,
  ADMINS_EA_WELLS_PATH,
  ADMINS_LEAD_ANALYSTS_PATH,
  ADMINS_LNG_FACILITIES_PATH,
  ADMINS_FEATURES_PATH,
  ADMINS_DIT_PATH,
  ADMINS_DIT_EVENT_PATH,
  ADMINS_CCUS_PATH,
  ADMINS_SMART_REPORTS_PATH,
  ADMINS_SMART_REPORTS_NEW_PATH,
  ADMINS_SMART_REPORTS_EDIT_REPORT_PATH,
  ADMINS_CONSOLIDATED_CASHFLOW_TEMPLATES_PATH,
  ADMINS_GIS_FILES_PATH,
  ...NEXUS_PATHS,
];

export const CCUS_PATHS = [CCUS_PATH];

export const M_A_TRANSACTIONS_PATHS = [
  M_A_TRANSACTIONS_PATH,
  M_A_TRANSACTIONS_OVERVIEW_PATH,
  M_A_TRANSACTIONS_TABLE_PATH,
  M_A_TRANSACTIONS_ANALYTICS_PATH,
  M_A_TRANSACTIONS_COMPANY_ANALYSIS_PATH,
];

export const M_A_OPPORTUNITIES_PATHS = [
  M_A_OPPORTUNITIES_PATH,
  M_A_OPPORTUNITIES_ANALYTICS_PATH,
  M_A_OPPORTUNITIES_TABLE_PATH,
];

export const INTELLIGENCE_PATHS = [PROPRIETARY_DOWNLOADS_PATH, CUSTOMER_DOWNLOADS_PATH];

export const PORTFOLIO_ANALYSIS_PATHS = [PORTFOLIO_ANALYSIS_PATH];

export const GHG_PATHS = [GHG_PATH];
export const GHG_SCOPE_3_PATHS = [GHG_SCOPE_3_PATH];
// Feature flag: enable_consolidated_live_models
export const CLM_PATHS = [CLM_PATH];

export const WEB_BASIC_PATHS = [
  COUNTRY_OVERVIEWS_PATH,
  DATA_DOWNLOADS_PATH,
  VALUATIONS_PATH,
  VALUATIONS_V2_PATH,
  LNG_ASSET_VALUATION_PATH,
  VIDEO_TUTORIALS_PATH,
  ...INTELLIGENCE_PATHS,
];

export const OIL_AND_GAS_MAP_PATHS = [OIL_AND_GAS_MAP_PATH];

export const PATHS = [
  ...ADMIN_PATHS,
  ...WEB_BASIC_PATHS,
  ...OIL_AND_GAS_MAP_PATHS,
  ...PUBLIC_PATHS,
  ...CCUS_PATHS,
  ...M_A_TRANSACTIONS_PATHS,
  ...M_A_OPPORTUNITIES_PATHS,
  ...INTELLIGENCE_PATHS,
  ...PORTFOLIO_ANALYSIS_PATHS,
  ...CLM_PATHS,
  ...GHG_PATHS,
  ...GHG_SCOPE_3_PATHS,
];

// Mapbox
export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1Ijoid2VsbGlnZW5jZSIsImEiOiJja2R1ZnMxZ2gwMGx6MnJwOW5yN2NoNHloIn0.a4F_hjdtzq0urr9MweXwnw';

// Wordpress Links
export const COOKIE_POLICY = 'https://welligence.com/cookie-policy/';
export const PRIVACY_POLICY = 'https://welligence.com/privacy-policy/';
export const TERMS_OF_USE = 'https://welligence.com/terms-of-use/';

// Feature Flag
export const SHINY_APPS_DEACTIVATED_IN_ENV = process.env.SHINY_APPS_DEACTIVATED_IN_ENV === 'true';

// get current path
export const getCurrentPath = path => {
  return PATHS.find(p => path.match(`^${p}`));
};

export const ANALYTICS_EVENT_ACTIONS = {
  buttonClick: 'ButtonClick',
  download: 'Download',
  filter: 'Filter',
  singleFilter: 'SingleFilter',
  layer: 'Layer',
  search: 'Search',
  chartSettings: 'chart_settings',
};
export const ANALYTICS_EVENTS = {
  login: 'login',
  pageview: 'pageview',
  event: 'event',
};

// Clients subscriptions
// Note: These need to match the feature names in the database
export const WEB_BASIC_SUBSCRIPTION = 'Web Basic Subscription';
export const OIL_AND_GAS_MAP_SUBSCRIPTION = 'Oil and Gas Map';
export const CCUS_SUBSCRIPTION = 'CCUS';
export const M_A_TRANSACTIONS_SUBSCRIPTION = 'M&A Transactions';
export const INTELLIGENCE_SUBSCRIPTION = 'Intelligence Notes';
export const PORTFOLIO_ANALYSIS_SUBSCRIPTION = 'Portfolio Analysis';
export const CLM_SUBSCRIPTION = 'Consolidated Live Models';
export const GHG_SUBSCRIPTION = 'GHG';
export const GHG_SCOPE_3_SUBSCRIPTION = 'GHG Scope 3';
export const CCUS_NOTES_SUBSCRIPTION = 'Intelligence Notes (CCUS)';
export const M_A_OPPORTUNITIES_SUBSCRIPTION = 'M&A Opportunities';
export const M_A_NOTES_SUBSCRIPTION = 'M&A Notes';

export const FEATURE_NOT_AVAILABLE_TOOLTIP =
  'This feature is not part of your subscription. Please contact your account team to discuss options for access.';

// Temporary solution for trials (admins, jefferies trial, goldman sachs trials, evercore)
// TODO: Remove if not needed for future features?
// export const consolidatedCashflowsAllowedUserIds = [
//   1675, 1689, 1690, 1236, 1688, 1235, 1668, 1252, 1170, 1669, 1673, 1205, 1674, 1244, 1678, 1679,
//   1222, 1080, 1199, 1217, 1145, 1212, 1480, 1676, 1677, 880, 1221, 1158, 1143, 1695, 175, 883, 1092,
//   786, 1529, 1196, 757, 434, 1079, 1204, 613, 1072, 986, 1011, 1393, 1036, 980, 490, 408, 1293, 811,
//   1356, 840, 984, 754, 1258, 1294, 723, 835, 751, 1587, 1588, 1192, 782, 839, 1203, 572, 928, 808,
//   790, 1404, 701, 1631, 804, 822, 812, 1661, 758, 981, 729, 1364, 1736, 88, 97, 108, 114, 139, 156,
//   167, 182, 185, 201, 207, 209, 235, 244, 261, 365, 414, 496, 562, 621, 617, 989, 184, 1756, 216,
//   1102, 974, 1438, 362, 317, 341, 245, 1662, 1654, 973, 676, 1440, 393, 238, 1530, 1531, 1532, 1607,
//   1608, 970, 1659, 1666, 447, 756, 1067, 1759,
// ];

// Global search URL parameter keys
//
// The ft_action should take only the GLOBAL_SEARCH_ACTION_* constant.
export const GLOBAL_SEARCH_URL_ACTION = 'ft_action';

// ft_legacy_id, ft_iso_code and ft_name are used to identify
// an entity (asset, block, country etc.) on screens
// no all will be always non-null, but their combination
// should be non-null to identify the entity sufficiently
export const GLOBAL_SEARCH_URL_LEGACY_ID = 'ft_legacy_id';
export const GLOBAL_SEARCH_URL_ISO_CODE = 'ft_iso_code';
export const GLOBAL_SEARCH_URL_NAME = 'ft_name';
export const GLOBAL_SEARCH_URL_GEOM = 'ft_geom';
export const GLOBAL_SEARCH_URL_COUNTRY_GEOM = 'ft_country_geom';

// Entity is a value introduced by global search feature.
// It comes from the GQL backend--each result has one--and
// it can take the following values: ASSET, BLOCK, COUNTRY,
// COMPANY, LEASE, PARTICIPATION
export const GLOBAL_SEARCH_URL_ENTITY = 'ft_entity';

// Global search actions
// Currently only the 'detail' action is supported
// The future, potential actions are:
//    'add' for adding to the current filter on a screen
//    'download' for downloading a xls, pdf etc.
export const GLOBAL_SEARCH_ACTION_DETAIL = 'detail';

const subject = 'Welligence Onboarding Session';
const formattedBody =
  "I'd like to schedule a platform onboarding session on the proposed date/time below:\n\nDate:\nTime:\n\nThanks";
export const requestTrainingMailTo = `mailto:info@welligence.com?subject=${encodeURIComponent(
  subject,
)}&body=${encodeURIComponent(formattedBody)}`;

// HARD-CODED HYDROCARBON TYPES
// TODO: Move to the backend
export const HYDROCARBON_TYPES = [
  { id: 1, oil: 'extra_heavy', type: 'oil', name: 'Extra Heavy Oil (<10° API)' },
  { id: 2, oil: 'heavy', type: 'oil', name: 'Heavy Oil (10° - 22° API)' },
  { id: 3, oil: 'medium', type: 'oil', name: 'Medium Oil (22° - 31° API)' },
  { id: 4, oil: 'light', type: 'oil', name: 'Light Oil (>31° API)' },
  { id: 5, oil: null, type: 'gas', name: 'Gas' },
];

export const LEASE_COUNTRY_ISO_CODES = ['USA', 'ALK'];

// Regions of interest for sign up form
export const REGIONS_OF_INTEREST = [
  { name: 'Sub-Saharan Africa' },
  { name: 'Middle East and North Africa' },
  { name: 'US Gulf of Mexico' },
  { name: 'North Sea (UK, Norway)' },
  { name: 'Latin America' },
  { name: 'All Regions' },
  { name: 'Greenhouse Gas Emissions' },
];
